
import { Enderecos } from '@funcate/sigweb-cti-api';
export class QuickSearchEnderecos 
{
    bearer: string;
    enderecos: any;
}
